function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect } from 'react';
import styles from './TitleField.module.scss';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import en from './locales/TitleField.en.json';
import cs from 'classnames';
import I18n from '../../I18n/I18n/I18n';
import ChevronCaret from '../../Icons/ChevronCaret/ChevronCaret';
import Accordion, { useAccordionContext } from '../../Accordion/Accordion/Accordion';
import AccordionItem from '../../Accordion/AccordionItem/AccordionItem';
import H from '../../H/H';
import HelpTemplate from '../HelpTemplate/HelpTemplate';
import { getInputDescription } from '../Widgets/wrapSchemaWidget';
import useIndentFields from '../IndentFieldsContext/useIndentFields';
import IndentFieldsContext from '../IndentFieldsContext/IndentFieldsContext';
var messages = normalizeLocaleData(en, '@dm/components.titleField');
function AccordionTitleButton(_ref) {
  var titleProps = _ref.titleProps,
    accordionProps = _ref.accordionProps,
    buttonProps = _ref.buttonProps,
    checked = _ref.checked,
    _text = _ref._text;
  var _useAccordionContext = useAccordionContext('AccordionTitleField'),
    dispatch = _useAccordionContext.dispatch;
  var itemCount = accordionProps.itemCount,
    dsa = accordionProps.dsa,
    description = accordionProps.description,
    escape = accordionProps.escape,
    expandForErrors = accordionProps.expandForErrors,
    groupUiIcons = accordionProps.groupUiIcons,
    help = accordionProps.help;
  var className = buttonProps.className,
    rest = _objectWithoutProperties(buttonProps, ["className"]);
  var hasItemCount = typeof itemCount !== 'undefined';
  useEffect(function () {
    if (expandForErrors) {
      dispatch({
        type: 'on:checkbox',
        payload: buttonProps.id
      });
    }
  }, [expandForErrors, dispatch, buttonProps.id]);
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.container, _defineProperty(_defineProperty({}, styles.dsa, !!dsa), styles.description, !!description))
  }, /*#__PURE__*/React.createElement(H, {
    id: accordionProps.id,
    className: cs(styles.heading, styles.bold, _defineProperty({}, titleProps ? titleProps.className || '' : '', !!(titleProps && titleProps.className))),
    visualLevel: 2
  }, /*#__PURE__*/React.createElement("button", Object.assign({}, rest, {
    id: accordionProps.id,
    className: cs(className, styles.button)
  }), /*#__PURE__*/React.createElement("span", {
    className: styles['wrapper--accordion']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.caret,
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(ChevronCaret, {
    direction: checked ? 'down' : 'right',
    width: 13,
    height: 13
  })), /*#__PURE__*/React.createElement("span", {
    className: styles['label--accordion']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: _text,
    escape: escape
  }), hasItemCount && /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    namespace: "@dm/components.titleField"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.count
  }, itemCount), /*#__PURE__*/React.createElement("span", {
    className: "assistive-text"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: {
      id: '@dm/components.titleField.countLabel',
      values: {
        count: itemCount
      }
    }
  })))))))), groupUiIcons, /*#__PURE__*/React.createElement(HelpTemplate, {
    description: getInputDescription(help),
    i18n: _text
  }));
}
export default function (props) {
  var className = props.className,
    children = props.children,
    accordionProps = _objectWithoutProperties(props, ["className", "children"]);
  var text = accordionProps.text,
    title = accordionProps.title,
    dsa = accordionProps.dsa,
    description = accordionProps.description,
    DescriptionField = accordionProps.DescriptionField;
  var _text = typeof text !== 'undefined' ? text : title;
  var _useIndentFields = useIndentFields(),
    enabled = _useIndentFields.enabled,
    indentClassName = _useIndentFields.indentClassName,
    indentRightClassName = _useIndentFields.indentRightClassName,
    childContext = _useIndentFields.childContext,
    parentContext = _useIndentFields.parentContext;
  return /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionItem, {
    title: _text,
    defaultOpen: props.defaultOpen,
    button: function button(_ref2) {
      var buttonProps = _ref2.buttonProps,
        checked = _ref2.checked;
      return /*#__PURE__*/React.createElement(AccordionTitleButton, {
        accordionProps: accordionProps,
        _text: _text,
        checked: checked,
        buttonProps: buttonProps,
        titleProps: {
          className: className
        }
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: dsa ? "".concat(indentClassName, " ").concat(indentRightClassName) : ''
  }, description && DescriptionField && /*#__PURE__*/React.createElement(DescriptionField, {
    description: description.text,
    className: dsa && enabled ? styles['no-margin'] : '',
    escape: description.escape
  }), /*#__PURE__*/React.createElement(IndentFieldsContext.Provider, {
    value: dsa ? parentContext : childContext
  }, children))));
}